import styled, { css } from 'styled-components';
import { media } from 'src/common/styles/breakpoints';
import { FC, PropsWithChildren } from 'react';
import { environment } from 'src/config/environment';

const Wrapper = styled.div<{
  sdk?: boolean;
}>`
  margin: 0 auto;
  max-width: 90rem;
  overflow: hidden;

  ${({ sdk }) =>
    sdk &&
    css`
      overflow-x: visible;
    `}

  ${({ sdk }) =>
    sdk
      ? css`
          padding: 0;
          width: 100%;
        `
      : css`
          padding: 2rem 1.25rem;
          min-height: 100vh;

          ${media.w.min.px576(css`
            padding: 2rem 1.875rem;
          `)}

          ${media.w.min.px1200(css`
            padding: 2rem 7.5rem;
          `)}
        `}
`;

export const LayoutContainer: FC<PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => {
  const sdk = environment.isWebSdk;

  return (
    <Wrapper sdk={sdk} className={className}>
      {children}
    </Wrapper>
  );
};
